
import { SILENT_AUTH_CHECK, showNotification } from "@/legacy/redux";
import cloneDeep from "lodash/cloneDeep";
import { setIn } from "./setIn";
import set from "lodash/set";
import { put, call, all, takeLatest } from "redux-saga/effects";
// import get from "lodash/get";
import useBatchHook from "./useBatchHook";
import useTestHook from "./useTestHook";
import { testgenCall, testgenReducer, testgenSaga } from "./testgensaga";
import { exportSaga, exportModel, exportRelease, exportTestData } from "./export.saga";
import { reducer as scopeReducer, saga as scopeSaga, useScope, setWorkspace, setProject, setRelease } from "./scope";
import * as loadMoreProjects from "./loadMoreProjects.saga";
import * as combinator from "./combinator.saga";
import * as combinatorV2 from "./combinatorV2.saga";
import * as decisionsRedux from "../pages/decisions/redux";
import * as loadProjectsForCurrentTotal from "./sagas/loadProjectsForCurrentTotal.saga";
import * as TempTimelineRedux from "@/components/TemporalValue/TempTimeline/redux";
import * as GraphTestRedux from "../pages/models/release/Test/GraphTest/redux";
import * as BuildDebugRedux from "../pages/models/release/Debug/redux";
import designerReducer from "../pages/models/release/Documents/designer.slice";
import documentsReducer from "../pages/documents/selectedDocument.slice";
import newDocumentsReducer from "../pages/documents/documents.slice";
import derivedTableEditorReducer, { REDUX_PROP as DERIVED_TABLE_EDITOR_REDUX_PROP } from "../pages/models/release/DataModel/route/DerivedTables/editor.slice";
import botsReducer from "../pages/bots/bots.slice";
import { isTemporal } from "../pages/decisions/DecisionDashboard/Reports/Details/UnifiedTimeline/types";
import * as workspacesNS from "./workspaces.saga";
import * as JsonInputV2Redux from "../pages/models/release/BatchDebug/redux/slice";
import * as decisionDesignerRedux from "../pages/models/release/Decision/redux";
import { config } from "../config";
import * as BatchDebugSagaNs from "../pages/models/release/BatchDebug/redux/saga";
import * as interviewReduxNS from "../pages/models/release/Interview/redux";
import * as fullReleaseRedux from "./fullRelease";
import * as contextMenuNS from "./contextMenu";
import * as sessionNS from './session.saga';
import * as dataTableSagaNS from '../pages/models/release/Documents/DataTable/saga'
import * as TestCasesTreeReduxNS from '../components/TestCasesTree/redux'
import { handleTenancyApiError, requireActiveTenancy } from "@/features/tenancy";

const host = config.BACKEND_URL;

export const batchCall = (releaseId, id, payload, index = 0) => ({
  type: "DCSVLY/BATCHCALL",
  release: releaseId,
  id,
  payload,
  index,
});

export const DRY_BATCH_CALL = "DCSVLY/DRY_BATCHCALL";
export const dryBatchCall = (releaseId, id, payload, cb) => ({
  type: DRY_BATCH_CALL,
  release: releaseId,
  id,
  payload,
  cb,
});


// TODO: add error handling, and loading messages
function* handleBatchCall(authProvider, action) {
  // Call the remote back API
  try {
    const validAuth = yield call(authProvider, "validAuth");
    if (!validAuth) {
      yield put({
        type: SILENT_AUTH_CHECK,
        forceLogin: true,
      });

      return false;
    }

    let headers = {
      "Content-Type": "application/json",
    };
    headers = authProvider("applyAuthentication", headers);
    headers["X-TENANCY"] = requireActiveTenancy();

    yield put({
      type: "DCSVLY/BATCHCALL_START",
      release: action.release,
      id: action.id,
      index: action.index,
    });
    // TODO: Hardcoded as we can't get config down here. Waiting on Alex to provide fix
    const uri = `${host}/decisionapi/batch/${action.id}/${action.release}`;
    console.log("uri", uri);
    const res = yield fetch(uri, {
      method: "POST",
      headers,
      body: JSON.stringify(action.payload),
    });
    const payload = yield res.json();
    if (!res.ok) {
      handleTenancyApiError(payload);
      throw Object.assign(new Error(payload.message || "Request failed"), payload);
    }

    yield put({
      type: "DCSVLY/BATCHCALL_SUCCESS",
      release: action.release,
      id: action.id,
      payload,
      index: action.index,
    });

    yield put({
      type: "DCSVLY/BATCHCALL_END",
      release: action.release,
      id: action.id,
      index: action.index,
    });
  } catch (error) {
    if (error.message) {
      yield put(showNotification(error.message, "error"));
    }

    yield put({
      type: "DCSVLY/BATCHCALL_ERROR",
      release: action.release,
      id: action.id,
      index: action.index,
    });
  }
}


/**
  @typedef SuccessPayload
  @type {{
    results?: Array<{
      result: import( '../pages/decisions/DecisionDashboard/Reports/Details/UnifiedTimeline/types' ).Node[ 'value' ];
    }>
  }}
*/

/** @type { ( p: SuccessPayload ) => Record< string, unknown> } */
const extractOutput = payload => {
  let first;
  console.log("p", payload);
  if (payload.goal) {
    first = payload;
  } else {
    const { results } = payload;
    if (results === undefined) return {};

    first = results[0];
  }
  if (first === undefined) return {};


  const { result } = first;

  return {
    outcome: isTemporal(result) ? result.temporal.ranges.map(it => it.v) : result,
  };
};

function* handleDryBatchCall(authProvider, action) {
  const validAuth = yield call(authProvider, "validAuth");
  if (!validAuth) {
    yield put({
      type: SILENT_AUTH_CHECK,
      forceLogin: true,
    });

    return false;
  }

  let headers = {
    "Content-Type": "application/json",
  };
  headers = authProvider("applyAuthentication", headers);
  headers["X-TENANCY"] = requireActiveTenancy();

  const uri = `${host}/decisionapi/batch/${action.id}/${action.release}`;

  const res = yield fetch(uri, {
    method: "POST",
    headers,
    body: JSON.stringify(action.payload),
  });
  const payload = yield res.json();

  if (!res.ok) {
    handleTenancyApiError(payload);
    yield put(showNotification(payload.message, "error"));

    return false;
  }

  action.cb(extractOutput(payload));
}
const defaultBatchState = {};
const batchReducer = (previousState = defaultBatchState, action) => {
  let new_state;
  switch (action.type) {
    case "DCSVLY/BATCHCALL_SUCCESS":
      new_state = setIn(previousState, `${action.release}.${action.id}.${action.index}.record`, action.payload);

      return new_state;
    case "DCSVLY/BATCHCALL_END":
    case "DCSVLY/BATCHCALL_ERROR":
      new_state = setIn(previousState, `${action.release}.${action.id}.${action.index}.loading`, false);

      return new_state;
    case "DCSVLY/BATCHCALL_START":
      new_state = setIn(previousState, `${action.release}.${action.id}.${action.index}.loading`, true);

      return new_state;

    case "DCSVLY/BATCHCALL_RESET": return defaultBatchState;

    /* case 'DCSVLY/TESTGEN_SUCCESS':

      new_state = cloneDeep(previousState);
      set(new_state, `${action.release}.${action.id}.record`, {cases: action.cases, attributes: action.attributes} );
      return new_state;
    */
    default:
      return previousState;
  }
};

function* batchSaga(authProvider) {
  yield all([
    takeLatest(
      action => action.type === "DCSVLY/BATCHCALL",
      handleBatchCall,
      authProvider,
    ),
    takeLatest(DRY_BATCH_CALL, handleDryBatchCall, authProvider),
  ]);
}

export {
  exportModel,
  exportRelease,
  exportTestData,
  useBatchHook,
  testgenCall,
  useTestHook,
  useScope,
  setWorkspace,
  setProject,
  setRelease,
};

export const sagas = [
  batchSaga,
  testgenSaga,
  scopeSaga,
  exportSaga,
  loadMoreProjects.saga,
  combinator.saga,
  combinatorV2.saga,
  loadProjectsForCurrentTotal.saga,
  decisionsRedux.saga,
  GraphTestRedux.saga,
  BuildDebugRedux.saga,
  workspacesNS.saga,
  decisionDesignerRedux.saga,
  BatchDebugSagaNs.saga,
  interviewReduxNS.saga,
  fullReleaseRedux.saga,
  contextMenuNS.saga,
  sessionNS.sessionSaga,
  dataTableSagaNS.saga,
  TestCasesTreeReduxNS.saga,
];

export const reducers = {
  batch: batchReducer,
  testgen: testgenReducer,
  scope: scopeReducer,
  [decisionsRedux.REDUX_PROP]: decisionsRedux.reducer,
  [TempTimelineRedux.REDUX_PROP]: TempTimelineRedux.reducer,
  [GraphTestRedux.REDUX_PROP]: GraphTestRedux.reducer,
  [BuildDebugRedux.REDUX_PROP]: BuildDebugRedux.reducer,
  documents: documentsReducer,
  designer: designerReducer,
  [JsonInputV2Redux.REDUX_PROP]: JsonInputV2Redux.reducer,
  ["documents-new"]: newDocumentsReducer,
  [DERIVED_TABLE_EDITOR_REDUX_PROP]: derivedTableEditorReducer,
  bots: botsReducer,
  [ interviewReduxNS.REDUX_PROP ]: interviewReduxNS.reducer,
  [ fullReleaseRedux.REDUX_PROP ]: fullReleaseRedux.reducer,
  [ contextMenuNS.REDUX_PROP ]: contextMenuNS.reducer,
  session: sessionNS.sessionReducer
};

export const middleware = [];
